import { trapFocus } from '../utils/trapFocus';

const openDrawer = (trigger: Element | null): void => {
  if (!trigger || !(trigger instanceof Element)) {
    return;
  }
  const target = document.getElementById(
    <string>trigger.getAttribute('data-controls')
  );

  target?.addEventListener('keydown', handleDrawerKeyEvent);
  const buttonClose = target?.querySelector('.drawer__close');

  if (target?.classList.contains('contains-accordion')) {
    const accordionTrigger = trigger.getAttribute('data-accordion-trigger');
    const accordionTarget = target.querySelector(
      `[aria-controls=${accordionTrigger}]`
    );
    if (accordionTarget instanceof HTMLElement) {
      accordionTarget.click();
    }
  }

  window._modalOpenedBy = trigger;

  target?.classList.add('is-active');
  document.documentElement.style.overflow = 'hidden';
  setTimeout(function () {
    target?.classList.add('is-visible');
    if (buttonClose instanceof HTMLElement) {
      buttonClose?.focus();
    }
  }, 50);

  target?.addEventListener('keydown', trapFocus);
};

export const closeDrawer = (element: Element): void => {
  const closestParent = element.closest('[data-drawer-target]');
  closestParent?.classList.remove('is-visible');
  document.documentElement.style.overflow = '';
  setTimeout(function () {
    closestParent?.classList.remove('is-active');
  }, 350);

  if (closestParent?.classList.contains('contains-accordion')) {
    const openAccordions = closestParent?.querySelectorAll(
      '.accordion--item--open'
    );
    openAccordions?.forEach((openAccordion) => {
      openAccordion.classList.remove('accordion--item--open');
      const accordionContent = openAccordion.querySelector(
        '.accordion--item--content'
      );

      if (accordionContent instanceof HTMLElement) {
        jQuery(accordionContent).slideToggle();
      }
    });
  }

  const openingButton = window._modalOpenedBy;

  if (openingButton && openingButton instanceof HTMLElement) {
    openingButton.focus();
  }
};

const handleDrawerKeyEvent = (event: Event | KeyboardEvent): void => {
  if (
    event instanceof KeyboardEvent &&
    event.key === 'Escape' &&
    event.target instanceof Element
  ) {
    const drawers = document.querySelectorAll('[data-drawer-target]');
    for (let i = 0; i < drawers.length; ++i) {
      if (drawers[i].classList.contains('is-active')) {
        closeDrawer(drawers[i]);
      }
    }
  }
};

export const initDrawerComponents = () => {
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof HTMLElement)) {
      return;
    }

    if (e.target.hasAttribute('data-drawer-trigger')) {
      e.preventDefault();
      openDrawer(e.target);
      return;
    }

    if (e.target.hasAttribute('data-drawer-close')) {
      e.preventDefault();
      closeDrawer(e.target);
      return;
    }
  });
};
